/* eslint-disable max-len */
import React, { Component } from 'react';
import clsx from 'clsx';
import querystring from 'querystring';
import lodash from 'lodash';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import {
  withWidth,
  Button,
  SvgIcon,
  Typography,
  Slide,
  Dialog,
  Snackbar
} from '@material-ui/core';

import { KeyboardArrowUp } from '@material-ui/icons';
import VisibilitySensor from 'react-visibility-sensor';

import {
  PRODUCTS_QUERY_REQUESTED,
  PRODUCTS_QUERY_RETRIEVED,
  PRODUCTS_QUERY_FAILED
} from '../../redux/actions/types';
import { getProducts } from '../../redux/actions/product';
import ProductMiniature from '../../commons/ProductMiniature';
import InfiniteScroll from '../../commons/InfiniteScroll';
import Sort from './Sort';
import { ReactComponent as OrderIcon } from '../../images/Icons/order.svg';
import { ReactComponent as FilterIcon } from '../../images/Icons/filter.svg';
import LoadingGif from '../../images/Loading.gif';
import { ReactComponent as HeartBroken } from '../../images/Heart_Roto.svg';
import ComingSoon from '../../images/Carteles/ComingSoon.svg';
import VacationMode from '../../images/Carteles/Vacaciones.svg';
import RTVMarketingFlash from '../../commons/RTVMarketingFlash';
import RTVFlashMessage from '../../commons/RTVFlashMessage';
import ProductFilter from './ProductFilter';
import Analytics from '../../services/Analytics';

const styles = theme => ({
  root: {
    minHeight: '200vh',
    padding: theme.spacing(1),
    [theme.breakpoints.down('sm')]: {
      display: 'flex',
      flexFlow: 'column',
      alignItems: 'center'
    }
  },
  filterButton: {
    margin: theme.spacing(2),
    width: '106px',
    color: '#707070',
    backgroundColor: '#f5f5f5',
    '& > *': {
      fontSize: '0.6rem'
    }
  },
  filterDesktopButton: ({ width }) => ({
    borderBottomLeftRadius:
      width !== 'xs' && width !== 'sm' ? 0 : theme.shape.borderRadius,
    borderBottomRightRadius:
      width !== 'xs' && width !== 'sm' ? 0 : theme.shape.borderRadius,
    margin: 0,
    height: '36px'
  }),
  floatingActions: {
    position: 'fixed',
    left: 0,
    top: '25vh',
    display: 'flex',
    flexFlow: 'column',
    alignItems: 'flex-start',
    zIndex: 3
  },
  filterTool: {
    display: 'flex',
    alignItems: 'flex-start',
    float: 'left',
    width: '275px',
    [theme.breakpoints.down('sm')]: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '100%'
    }
  },
  floatingButton: {
    width: '105px',
    marginTop: theme.spacing(1),
    backgroundColor: '#f5f5f5',
    color: '#707070',
    borderTopLeftRadius: 0,
    borderBottomLeftRadius: 0,
    boxShadow: '0 0 10px 0 rgba(112, 112, 112, 0.5)',
    display: 'flex',
    justifyContent: 'flex-start',
    '& > *': {
      fontSize: '0.5rem'
    }
  },
  floatingIcon: {
    '& > path': {
      stroke: `${theme.palette.primary.main} !important`
    },
    '& > g': {
      '& > path': {
        stroke: `${theme.palette.primary.main} !important`
      }
    }
  },
  productList: {
    display: 'block',
    overflow: 'visible',
    textAlign: 'center',
    '& > *': {
      display: 'inline-block',
      margin: theme.spacing(1, 0.5, 0, 0)
    },
    [theme.breakpoints.down('sm')]: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexWrap: 'wrap'
    },
    [theme.breakpoints.down('xs')]: {
      '& > *': {
        margin: 0
      }
    }
  },
  loadingSection: {
    display: 'block',
    textAlign: 'center',
    marginTop: '150px'
  },
  popper: {
    marginTop: 0
  },
  notVisible: {
    display: 'none'
  },
  filterContainer: {
    margin: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      margin: 0
    }
  }
});

class Shop extends Component {
  constructor(props) {
    super(props);
    const decodedQuery = querystring.decode(
      props.location.search.replace('?', '')
    );

    this.filterButtonRef = React.createRef();
    this.sortButtonRef = React.createRef();

    const notUndefinedDefaultFilter = props.defaultFilter
      ? Object.keys(props.defaultFilter).reduce((filter, currentFilter) => {
          if (
            props.defaultFilter[currentFilter] !== undefined ||
            (Array.isArray(props.defaultFilter[currentFilter]) &&
              props.defaultFilter[currentFilter].length > 0)
          ) {
            // eslint-disable-next-line no-param-reassign
            filter[currentFilter] = props.defaultFilter[currentFilter];
          }
          return filter;
        }, {})
      : {};

    this.state = {
      defaultFilter: notUndefinedDefaultFilter,
      queryString: decodedQuery.query || '',
      query: {
        query: decodedQuery.query || '',
        sort: decodedQuery.sort || '',
        ...notUndefinedDefaultFilter
      },
      filterQuery: {},
      sortQuery: decodedQuery.sort ? { sort: decodedQuery.sort } : {},
      filterMenuOpen: false,
      sortMenuOpen: false,
      visibleActions: false,
      products: [],
      loadingProducts: false,
      hasMoreProducts: false,
      reloadCount: 0,
      mobile: props.width === 'xs' || props.width === 'sm',
      firstLoad: true,
      noProducts: false,
      pageSize: props.pageSize === undefined ? 40 : props.pageSize,
      hadProducts: true,
      retryCount: 0,
      failedRequest: false,
      clearFilterCount: 0
    };
  }

  componentDidMount() {
    this.props.getProducts(
      this.state.query,
      1,
      this.state.pageSize,
      this.props.favorites
    );
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.location.search !== this.props.location.search) {
      const decodedQuery = querystring.decode(
        this.props.location.search.replace('?', '')
      );
      // If you are on /products and click on 'Promos' the url will change and add
      // a `rel` query param to communicate the page that it has to reload to take
      // action.
      if (!this.state.firstLoad && decodedQuery.rel === '') {
        window.location.reload();
      }
      if (
        this.state.queryString !== decodedQuery.query &&
        decodedQuery.query !== undefined
      ) {
        this.setState(
          state => ({
            query: { query: decodedQuery.query },
            queryString: decodedQuery.query,
            reloadCount: state.reloadCount + 1,
            clearFilterCount: state.clearFilterCount + 1
          }),
          () => {
            this.props.getProducts(
              this.state.query,
              1,
              this.state.pageSize,
              this.props.favorites
            );
          }
        );
      }
    }

    if (prevProps.width !== this.props.width) {
      const mobileNow = this.props.width === 'xs' || this.props.width === 'sm';
      if (
        (this.state.mobile && !mobileNow) ||
        (!this.state.mobile && mobileNow)
      ) {
        this.setState({ mobile: mobileNow });
      }
    }

    if (prevState.mobile !== this.state.mobile) {
      window.location.reload();
    }

    if (prevState.reloadCount !== this.state.reloadCount) {
      this.setState({
        products: [],
        firstLoad: true
      });
    }

    if (!lodash.isEqual(prevProps.defaultFilter, this.props.defaultFilter)) {
      const notUndefinedDefaultFilter = this.props.defaultFilter
        ? Object.keys(this.props.defaultFilter).reduce(
            (filter, currentFilter) => {
              if (
                this.props.defaultFilter[currentFilter] !== undefined ||
                (Array.isArray(this.props.defaultFilter[currentFilter]) &&
                  this.props.defaultFilter[currentFilter].length > 0)
              ) {
                // eslint-disable-next-line no-param-reassign
                filter[currentFilter] = this.props.defaultFilter[currentFilter];
              }
              return filter;
            },
            {}
          )
        : {};
      this.setState(
        state => ({
          // As we change the defaultFilter, the previous one is not important
          // to us anymore, so we just set the query to be the new `notUndefinedDefaultFilter`.
          query: notUndefinedDefaultFilter,
          reloadCount: state.reloadCount + 1
        }),
        () => {
          this.props.getProducts(
            this.state.query,
            1,
            this.state.pageSize,
            this.props.favorites
          );
        }
      );
    }

    if (prevProps.productsStatus !== this.props.productsStatus) {
      if (this.props.productsStatus === PRODUCTS_QUERY_REQUESTED) {
        this.setState({
          loadingProducts: true,
          failedRequest: false
        });
      }
      if (this.props.productsStatus === PRODUCTS_QUERY_RETRIEVED) {
        if (this.state.firstLoad) {
          Analytics.productsListVisit(this.props.products.slice(0, 4));
        }
        this.setState(state => ({
          ...state,
          products: [...state.products, ...this.props.products],
          hasMoreProducts: this.props.products.length === this.state.pageSize,
          loadingProducts: false,
          firstLoad: false,
          noProducts: state.firstLoad && this.props.products.length === 0,
          hadProducts:
            !state.hadProducts && this.props.products.length > 0
              ? true
              : state.hadProducts
        }));
      }
      if (this.props.productsStatus === PRODUCTS_QUERY_FAILED) {
        this.setState(state => ({
          retryCount: state.retryCount + 1,
          loadingProducts: false,
          hasMoreProducts: state.retryCount < 3,
          failedRequest: state.retryCount >= 3
        }));
      }
    }
  }

  filterVisibilityChanged = visible => {
    this.setState({ visibleActions: visible });
  };

  handleFloatingAction = tool => {
    window.scroll(0, !tool ? 0 : 125);
    if (tool === 'order') {
      this.openSort();
    }
    if (tool === 'filter') {
      this.openFilter();
    }
  };

  handleLoadMore = currentPage => {
    this.props.getProducts(
      this.state.query,
      currentPage,
      this.state.pageSize,
      this.props.favorites
    );
  };

  handleFilterChange = filter => {
    this.props.history.replace({
      search: querystring.encode({
        query: this.state.queryString,
        ...filter,
        sort: this.state.sortQuery.sort
      })
    });
    let user = this.props.dresserView
      ? this.state.defaultFilter.user
      : filter.user || undefined;

    this.setState(
      state => ({
        ...state,
        sortMenuOpen: false,
        filterQuery: filter,
        query: {
          // We are not using defaultFilter to be persistent, but we'll keep
          // the persistence logic of it only for dressers where you should only see
          // the user's products.
          user,
          followings: filter.users === 'followings' ? 1 : 0,
          query: state.queryString,
          ...filter,
          ...state.sortQuery
        },
        reloadCount: state.reloadCount + 1
      }),
      () => {
        this.props.getProducts(
          this.state.query,
          1,
          this.state.pageSize,
          this.props.favorites
        );
      }
    );
  };

  handleSortChange = sort => {
    this.props.history.replace({
      search: querystring.encode({
        ...this.state.query,
        sort
      })
    });
    this.setState(
      state => ({
        ...state,
        filterMenuOpen: false,
        sortMenuOpen: false,
        sortQuery: { sort },
        query: {
          ...state.query,
          sort
        },
        reloadCount: state.reloadCount + 1
      }),
      () => {
        this.props.getProducts(
          this.state.query,
          1,
          this.state.pageSize,
          this.props.favorites
        );
      }
    );
  };

  openSort = () => {
    this.setState({
      filterMenuOpen: false,
      sortMenuOpen: true
    });
  };

  openFilter = () => {
    this.setState({
      filterMenuOpen: true,
      sortMenuOpen: false
    });
  };

  handleClose = menu => {
    this.setState({ [menu]: false });
  };

  removeQueryString = () => {
    this.props.history.replace({
      search: querystring.encode({
        ...this.state.query,
        query: ''
      })
    });

    this.setState(
      state => ({
        ...state,
        queryString: '',
        query: {
          ...state.query,
          // We are not using defaultFilter to be persistent, but we'll keep
          // the persistence logic of it only for dressers where you should only see
          // the user's products.
          user: this.props.dresserView
            ? this.state.defaultFilter.user
            : undefined,
          query: ''
        },
        reloadCount: state.reloadCount + 1
      }),
      () => {
        this.props.getProducts(
          this.state.query,
          1,
          this.state.pageSize,
          this.props.favorites
        );
      }
    );
  };

  render() {
    const { classes, favorites } = this.props;
    const { noProducts } = this.state;

    return (
      <div className={classes.root}>
        <Snackbar
          open={this.state.failedRequest}
          color="primary"
          message="Parece que hubo un problema al cargar el listado de productos"
          autoHideDuration={600}
          action={
            <Button
              color="primary"
              size="small"
              onClick={() => window.location.reload()}
            >
              RECARGAR PAGINA
            </Button>
          }
        />
        {((this.props.dresserView && (!noProducts || this.state.hadProducts)) ||
          !this.props.dresserView) && (
          <Slide
            in={
              !this.state.visibleActions &&
              !this.state.sortMenuOpen &&
              !this.state.filterMenuOpen
            }
            timeout={200}
            direction="right"
          >
            <div
              className={clsx(classes.floatingActions, {
                [classes.notVisible]: this.props.vacationMode
              })}
            >
              <Button
                variant="contained"
                className={classes.floatingButton}
                onClick={() => this.handleFloatingAction()}
              >
                <KeyboardArrowUp
                  style={{
                    width: '0.9rem',
                    height: '0.9rem',
                    marginRight: '4px'
                  }}
                  color="primary"
                />
                SUBIR
              </Button>
              <Button
                variant="contained"
                className={classes.floatingButton}
                onClick={() => this.handleFloatingAction('order')}
              >
                <SvgIcon
                  color="primary"
                  viewBox="0 0 25.513 15.157"
                  style={{
                    width: '0.9rem',
                    height: '0.9rem',
                    marginRight: '4px'
                  }}
                >
                  <OrderIcon className={classes.floatingIcon} />
                </SvgIcon>
                ORDENAR
              </Button>
              <Button
                variant="contained"
                className={classes.floatingButton}
                onClick={() => this.handleFloatingAction('filter')}
              >
                <SvgIcon
                  color="primary"
                  viewBox="0 0 25.513 15.157"
                  style={{
                    width: '0.9rem',
                    height: '0.9rem',
                    marginRight: '4px'
                  }}
                >
                  <FilterIcon className={classes.floatingIcon} />
                </SvgIcon>
                FILTRAR
              </Button>
            </div>
          </Slide>
        )}

        {(this.props.width === 'xs' || this.props.width === 'sm') && (
          <Dialog
            fullScreen
            open={this.state.filterMenuOpen}
            onClose={() => this.handleClose('filterMenuOpen')}
            keepMounted
          >
            <ProductFilter
              visible
              favorites={this.props.favorites}
              dresserView={this.props.dresserView}
              onClose={() => this.handleClose('filterMenuOpen')}
              onFilterChange={this.handleFilterChange}
              defaultFilter={this.props.defaultFilter}
              queryString={this.state.queryString}
              removeQueryString={this.removeQueryString}
            />
          </Dialog>
        )}

        <Sort
          favorites={favorites}
          open={this.state.sortMenuOpen}
          anchorEl={this.sortButtonRef.current}
          onClose={() => this.handleClose('sortMenuOpen')}
          changeSort={this.handleSortChange}
        />
        {((this.props.dresserView && (!noProducts || this.state.hadProducts)) ||
          !this.props.dresserView) && (
          <VisibilitySensor
            offset={{ top: 96 }}
            partialVisibility
            scrollCheck
            onChange={this.filterVisibilityChanged}
          >
            <div
              className={clsx(classes.filterTool, {
                [classes.notVisible]: this.props.vacationMode
              })}
            >
              <div className={classes.filterContainer}>
                <Button
                  ref={this.filterButtonRef}
                  onClick={this.openFilter}
                  variant="contained"
                  className={clsx(classes.filterButton, {
                    [classes.filterDesktopButton]:
                      this.props.width !== 'xs' && this.props.width !== 'sm'
                  })}
                >
                  <SvgIcon
                    viewBox="0 0 19.776 17.999"
                    style={{
                      width: '0.9rem',
                      height: '0.9rem',
                      marginRight: '4px'
                    }}
                  >
                    <FilterIcon />
                  </SvgIcon>
                  FILTRAR
                </Button>
                {!this.state.mobile && (
                  <ProductFilter
                    dresserView={this.props.dresserView}
                    visible={!this.props.vacationMode}
                    clearFilterCount={this.state.clearFilterCount}
                    onFilterChange={this.handleFilterChange}
                    defaultFilter={this.props.defaultFilter}
                    queryString={this.state.queryString}
                    removeQueryString={this.removeQueryString}
                  />
                )}
              </div>
              <Button
                ref={this.sortButtonRef}
                variant="contained"
                onClick={this.openSort}
                className={classes.filterButton}
                style={
                  this.props.width !== 'xs' && this.props.width !== 'sm'
                    ? { marginLeft: '-160px' }
                    : {}
                }
              >
                <SvgIcon
                  viewBox="0 0 25.513 15.157"
                  style={{
                    width: '0.9rem',
                    height: '0.9rem',
                    marginRight: '4px'
                  }}
                >
                  <OrderIcon />
                </SvgIcon>
                ORDENAR
              </Button>
            </div>
          </VisibilitySensor>
        )}

        {!this.props.dresserView && (
          <RTVMarketingFlash location="STORE_LOCATIONS" liveEnabled />
        )}

        {this.props.errorMessage && (
          <RTVFlashMessage
            emoji={'😄'}
            emojiLabel="cara sonriente"
            message="Parece que tu busqueda no trajo resultados, pero podes ver aca toda la tienda!"
          />
        )}

        {this.state.products.length === 0 && this.state.loadingProducts && (
          <div className={classes.loadingSection}>
            <img src={LoadingGif} alt="loading" />
            <Typography color="primary">Cargando Productos...</Typography>
          </div>
        )}
        <div className={classes.productList}>
          {this.state.products.length === 0 &&
            !this.state.loadingProducts &&
            (!this.props.dresserView ||
              (this.props.dresserView && this.state.hadProducts)) &&
            !this.props.vacationMode && (
              <div
                style={{
                  display: 'flex',
                  flexFlow: 'column',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}
              >
                <HeartBroken style={{ height: '6rem', width: '6rem' }} />
                <Typography variant="h6">
                  No encontramos productos :(
                </Typography>
              </div>
            )}
          {noProducts &&
            !this.state.hadProducts &&
            this.props.dresserView &&
            !this.props.vacationMode && (
              <div
                style={{
                  display: 'flex',
                  flexFlow: 'column',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}
              >
                <img
                  style={{ width: '300px' }}
                  src={ComingSoon}
                  alt="Comming soon..."
                />
              </div>
            )}
          {this.props.vacationMode && (
            <div
              style={{
                display: 'flex',
                flexFlow: 'column',
                alignItems: 'center',
                justifyContent: 'center'
              }}
            >
              <img
                style={{ maxWidth: '500px' }}
                src={VacationMode}
                alt="Comming soon..."
              />
            </div>
          )}
          {this.state.products.length > 0 && !this.props.vacationMode && (
            <InfiniteScroll
              pageStart={2}
              pageSize={10}
              active={
                this.props.active === undefined ? this.props.active : true
              }
              mode={this.state.reloadCount}
              hasMore={this.state.hasMoreProducts}
              loadMore={this.handleLoadMore}
              loading={this.state.loadingProducts}
              retryCount={this.state.retryCount}
              threshold={2500}
            >
              {this.state.products.map((product, index) => (
                <ProductMiniature
                  key={product.id + index}
                  product={product}
                  shopView
                />
              ))}
            </InfiniteScroll>
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  products: state.product.products,
  productsStatus: state.product.status,
  productsError: state.product.error,
  localStats: state.user.localStats
});

const mapDispatchToProps = dispatch => ({
  getProducts: (query, page, pageSize, favorites) =>
    dispatch(getProducts(query, page, pageSize, favorites))
});

export default withStyles(styles)(
  withWidth()(withRouter(connect(mapStateToProps, mapDispatchToProps)(Shop)))
);
